/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for Api services
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'https://https://media.us-west-2.us.dev.api.mitel.io/2017-09-01';
}

export interface ApiConfigurationInterface {
  rootUrl?: string;
}
